<div class="expanded-box">
  <div class="expanded-item-wrapper">
    <h3>Datos básicos</h3>
    <span><strong>Serial:</strong> {{ row.serial }} <br /></span>
    <span><strong>Fecha de compra:</strong> {{ row.purchaseDate }}</span>
    <span><strong>Proveedor:</strong> {{ row.supplier }} </span>
    <span><strong>Filial:</strong> {{ row.branch }}</span>
    <span
      ><strong>Costo Unitario:</strong
      >{{ row.unitCost | currency: "USD" : "symbol" : "1.2-2" }}</span
    >
    <span><strong>Referencia:</strong> {{ row.modelReference }}</span>
    <span
      ><strong>Número de orden de compra:</strong> {{ row.purchaseOrder }}</span
    >
  </div>
  <div class="expanded-item-wrapper">
    <h3>Datos técnicos</h3>
    <span><strong>Marca:</strong> {{ row.brand }} <br /></span>
    <span
      ><strong>Referencia del modelo:</strong> {{ row.modelReference }}</span
    >
    <span
      ><strong>Tipo de tiro:</strong>
      {{ row.draftType === "FORCED" ? "Forzado" : "Natural" }}
    </span>
    <span><strong>Litraje:</strong> {{ row.capacityLiters }} litros</span>
  </div>
  <div class="expanded-item-wrapper">
    <h3>Información adicional</h3>
    <span><strong>Estado actual:</strong> {{ row.status }} <br /></span>
    <span
      ><strong>Fecha y hora de carga al sistema:</strong>
      {{
        row.createdAt | date: "MMMM d 'de' y: h:mm a" : "" : "es-CO" | titlecase
      }}
      <br
    /></span>
    <p [style]="{ whiteSpace: 'normal' }">
      <strong>Usuario:</strong> USUARIO QUR CARGO EL CALENTADOR <br />
    </p>
  </div>
  <div class="actions">
    <app-button
      class="button"
      variant="secondary"
      label="Cerrar"
      (click)="handleClose()"
    ></app-button>
    <app-button
      class="button"
      variant="primary"
      label="Aprobar"
      (click)="handleApprove()"
    ></app-button>
    <app-button
      class="button"
      variant="secondary"
      label="Rechazar"
      (click)="handleDeny()"
    ></app-button>
  </div>
</div>
